<template>
    <!-- Componente para mostrar las versiones del modelo en desktop en el configurador de modelos -->
    <div>
        <div class="versions flex leading-snug justify-center mt-20 text-sm shadow">
            <div
                v-for="trim in trims"
                :key="trim.id"
                class="version cursor-pointer py-3 flex-grow flex justify-center"
                :class="trimSelected.display_name === trim.display_name ? 'bg-brown': 'bg-light-brown'"
                @click="changeTrim(trim.display_name)"
            >
                <div>
                    <p class="font-medium">{{ trim.name }}</p>
                    <p>${{ formatPrice(trim.price) }} MXN</p>
                </div>
            </div>
        </div>
        <div class="model-info mt-8 sm:mt-12 flex justify-center lg:justify-start flex-wrap">
            <div class="w-full flex justify-center lg:justify-between">
                <div class="left text-center lg:text-left leading-tight lg:leading-snug">
                    <h1 class="font-bold text-2xl sm:text-3xl lg:text-2xl">{{ trimSelected.name }} <span
                            class="font-light ml-1"
                        >{{ modelYear }}</span></h1>
                    <h1 class="font-bold text-2xl sm:text-3xl lg:text-2xl pl-10 lg:pl-0">
                        ${{ formatPrice(trimSelected.price) }} <span class="text-sm sm:text-base">MXN</span></h1>
                </div>
                <!-- <div class="right hidden lg:block">
                    <a class="text-xs bg-light-brown py-3 pl-4 pr-5 font-bold" href="#">
                        <img class="w-4 inline-block mr-2" :src="url + '/images/quotation_form/pdf_icon.png'" alt="PDF">
                        Ficha técnica
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["trims", "trimSelected", "modelYear"],
    methods: {
        formatPrice(price, n, x) {
            let re =
                "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
            return parseInt(price)
                .toFixed(Math.max(0, ~~n))
                .replace(new RegExp(re, "g"), "$&,");
        },
        changeTrim(trimId) {
            this.$emit("change-trim", trimId);
        },
    },
};
</script>

<style>

</style>